import type { HowToBlockInput } from "@/lib/structured-data"

/**
 * Single source of truth for the homepage "How it works" steps. Consumed by:
 *  - components/home/how-it-works-illustrated.tsx (visual 3-step section, maps
 *    each step to its SVG illustration by index)
 *  - app/page.tsx (HowTo JSON-LD, rendered server-side OUTSIDE the Suspense
 *    boundary so it lands in the statically-prerendered HTML for Googlebot)
 *
 * Keeping the copy here, in a plain (non-"use client") module, lets the server
 * page import it for schema without pulling in the client component, and
 * guarantees the structured data can never drift from the visible steps.
 */
export const homepageHowToSteps = [
  { name: "Snap a close-up", text: "Daylight close-up. No special gear." },
  { name: "We identify the species", text: "Spots the grass types behind nearly every U.S. lawn." },
  { name: "You get a year-long plan", text: "Tasks for every week, tuned to your zip." },
]

export const homepageHowToBlock: HowToBlockInput = {
  name: "How to identify your grass type from a photo",
  description:
    "Upload one daylight close-up of your lawn and get the most likely grass species, a confidence score, and a year-long care plan in about 15 seconds.",
  steps: homepageHowToSteps,
}
